`use strict`;

class OnBoardTutorialController {
    constructor () {
        this.active = false;
    }

    registerFeature(feature) {
        this.feature = feature;
    }

    updateActiveStatus(active) {
        this.active = active;
    }

    showThisPage(featureName) {
        if (this.feature) {
            this.feature.showThisPage(featureName);
        }
    }

    isFeatureAvailable(featureName) {
        if (!featureName) {
            return false;
        }

        if (this.feature) {
            return this.feature.isFeatureAvailable(featureName);
        }

        return false;
    }

    getActiveStatus() {
        return this.active;
    }

    setVisibility(show) {
        this.updateActiveStatus(show);

        if (this.feature) {
            this.feature.setTutorialModalVisibility(show);
        }
    }

    async getOnBoardTutorialStatus(statusFromMeetingSettings = true) {
        const user = getDefaultLoginInfo();
        this.active = await getOnBoardTutorialStatus(user.id) && statusFromMeetingSettings;
        this.setVisibility(this.active);
    }

    updateFeatureList() {
        if (this.feature) {
            this.feature.updateFeatureList()
        }
    }

    addCommandMenuItemForThisController(menuController, itemName, itemText, featureName) {
        if (!menuController || !this.isFeatureAvailable(featureName)) {
            return;
        }

        let menuItem = menuController.menuData.getThisMenuData(itemName);
        if (!menuItem) {
            menuItem = new ClickMenuItem(itemName, itemText ? itemText : 'Tutorial', false, function () {
                this.showThisPage(featureName);
            }.bind(this));

            menuController.addCommandMenuItem(menuItem);
        }
    }

    showIcon (show) {
        let item = document.getElementById('userNavigationControl');
        if (item) {
            item.style.display = show ? 'flex' : 'none';
        }
    }
}

let instance = new OnBoardTutorialController();

export default instance;